import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { getMeta } from '@precon-tools-suite-by-shared/browser-utils';

export type CreateApplicationInsightsInstanceOptions = {
    instrumentationKey?: string;
    appId?: string;
};

export function createApplicationInsightsInstance(
    options?: CreateApplicationInsightsInstanceOptions
): ApplicationInsights | undefined {
    const instrumentationKey =
        options?.instrumentationKey ?? getMeta('instrumentation-key');
    const appId = options?.appId ?? getMeta('app-client-id');

    if (!instrumentationKey) {
        console.warn(
            `No instrumentation key found. meta-element 'instrumentation-key' empty.`
        );
        return undefined;
    }

    return new ApplicationInsights({
        config: {
            instrumentationKey,
            appId,
        },
    });
}
